import { IScalingConfiguration } from 'interfaces/i-pitch-scaling';
import { RowWithID } from 'interfaces/tables/main';
import { IMlbPlayer } from 'lib_ts/interfaces/mlb-stats-api/i-player';

export enum ImportAction {
  Append = 'append',
  Merge = 'merge',
  Replace = 'replace',
}

interface IImportPitcherConfiguration {
  pitcher: IMlbPlayer;
  listID: string | undefined;
  action: ImportAction;
  scaling: IScalingConfiguration;
}

export interface IImportPitcherConfigurationRow
  extends IImportPitcherConfiguration, RowWithID {}
